import {Button, Flex} from '@chakra-ui/react';
import {colors} from 'components/providers';
import {useDesktop} from 'hooks';
import {FC, useContext} from 'react';
import {VisibilityContext} from 'react-horizontal-scrolling-menu';

import {IconArrow} from './components';

interface Props {
  variant: 'left' | 'right';
  zIndex?: number;
}

export const ScrollMenuArrow: FC<Props> = ({variant, zIndex = 99}) => {
  const isDesktop = useDesktop();
  const {scrollNext, scrollPrev, scrollContainer, useIsVisible} = useContext(VisibilityContext);
  const isFirstItemVisible = useIsVisible('first', true);
  const isLastItemVisible = useIsVisible('last', false);

  const handleClick = () => {
    variant === 'left' ? scrollPrev() : scrollNext();
  };

  const scrollEl = scrollContainer?.current;

  const isAtStart = scrollEl?.scrollLeft === 0;
  const isAtEnd = scrollEl ? Math.ceil(scrollEl.scrollLeft + scrollEl.offsetWidth) >= scrollEl.scrollWidth : false;

  const isDisabled = variant === 'left' ? isFirstItemVisible || isAtStart : isLastItemVisible || isAtEnd;
  return (
    <Button
      onClick={handleClick}
      display={isDisabled || !isDesktop ? 'none' : 'flex'}
      w={['30px', '46px']}
      h={['40px', '46px']}
      sx={{
        borderRadius: '50%',
        boxShadow: '0px 3px 10px rgba(0, 0, 0, 0.25)',
        position: 'absolute',
        zIndex,
        bg: colors.white,
        top: '27%',
      }}
      right={variant === 'right' ? '7px' : undefined}
      left={variant === 'left' ? '7px' : undefined}
      className={`slider-arrow slider-arrow-${variant}`}
      _focus={{border: 'none'}}
      _hover={{
        bg: colors.pink,
        color: colors.white,
        '.icon svg path': {
          fill: 'white',
        },
      }}
      aria-label="Arrow Button"
    >
      <Flex
        className="icon"
        justifyContent="center"
        alignItems="center"
        transform={`rotate(${variant === 'left' ? '180deg' : 0})`}
      >
        <IconArrow />
      </Flex>
    </Button>
  );
};
